

















































































import Vue from "vue";
import AgreementService from "@/services/agreementService";
import { File } from "@/models/agreement";
import AdminService from "@/services/adminService";
import TeamService from "@/services/getTeams";
import { TheTeam } from "@/models/the-team";

export default Vue.extend({
  data() {
    return {
      teams: [] as TheTeam[],
      isLoaded: false,
      deleting: false
    };
  },
  name: "Teams",

  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoaded = true;
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const teamService = new TeamService(jwt);
        const response = await teamService.getTeams();
        if (response && response.status == 200) {
          this.teams = response.data;
        }
      }
      this.isLoaded = false;
    },
    async deleteTeams(e, name, key) {
      e.preventDefault();
      if (this.deleting) {
        return;
      }
      if (confirm("Are you sure you want to delete " + name)) {
        this.isLoaded = true;
        const jwt = window.localStorage.getItem("jwt");
        if (jwt) {
          const adminService = new AdminService(jwt);
          try {
            const formData = new FormData();
            formData.append("key", key.trim());
            const response = await adminService.deleteTeams(formData);
            if (response && response.status == 200) {
              if (response.data) {
                alert(response.data);
                await this.getList();
                this.isLoaded = false;
              }
            }
          } catch (e) {
            alert(JSON.stringify(e.response.data));
            this.isLoaded = false;
          }
        }
      }
    },
    async goToCreateTeam() {
      await this.$router.push("/admin-create-teams");
    }
  }
});
